import { __decorate } from "tslib";
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { elements } from './sdb-elements.js';
import '@polymer/paper-tooltip/paper-tooltip.js';
/**
 * Options element, used to hold up to 4 iconbutton elements
 *
 * @slot 1 - the first slot
 * @slot 2 - the second slot
 * @slot 3 - the third slot
 * @slot 4 - the fourth slot
 * SLOT 5 IS USED FOR PROFILE MENU
 * @slot 6 - the sixth slot

 */
let SDBNavUserMenu = class SDBNavUserMenu extends LitElement {
    constructor() {
        super(...arguments);
        this.username = '';
        this.opened = false;
        this.tooltipPosition = 'bottom';
    }
    render() {
        return html `
            <span class="username"><slot name="username"></slot></span>
            <slot name="1" class="contentOptionsIcon"></slot>
            <slot name="2" class="contentOptionsIcon"></slot>
            <slot name="3" class="contentOptionsIcon"></slot>
            <slot name="4" class="contentOptionsIcon"></slot>
            <sdb-content-iconbutton
                part="profile-button"
                id="profileBtn"
                icon="fal fa-user"
                @click=${() => this.toggleMenu()}
            ></sdb-content-iconbutton>
            ${this.tooltipText
            ? html `
                      <paper-tooltip
                          for="profileBtn"
                          position="${this.tooltipPosition}"
                          animation-delay="0"
                      >
                          ${this.tooltipText}
                      </paper-tooltip>
                  `
            : html ``}
            <slot name="6" class="contentOptionsIcon"></slot>

            <div id="profileMenu" ?opened=${this.opened}>
                <div class="overlay" @click="${() => this.toggleMenu()}"></div>
                <div id="profileMenuContent">
                    <slot name="content"></slot>
                </div>
                <div id="closeBtn">
                    <sdb-content-icon
                        part="close-button"
                        size="18"
                        icon="fal fa-chevron-up"
                        @click=${() => this.toggleMenu()}
                    >
                    </sdb-content-icon>
                </div>
            </div>
        `;
    }
    toggleMenu() {
        if (this.opened) {
            this.opened = false;
        }
        else {
            this.opened = true;
        }
    }
};
SDBNavUserMenu.styles = [
    elements,
    css `
            :host {
                display: grid;
                grid-auto-columns: fit-content;
                grid-auto-flow: column;
                justify-items: right;
                grid-column-gap: 10px;
            }

            :host .contentOptionsIcon {
                justify-content: center;
                align-content: center;
            }

            :host .username {
                display: inline-block;
                width: fit-content;
                color: var(--text-primary);
                font-weight: 600;
                text-transform: uppercase;
                padding-right: 10px;
            }

            .overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: transparent;
                z-index: 2;
            }

            :host #profileMenu {
                display: none;
                min-width: 200px;
                max-width: 300px;
                height: auto;
                position: absolute;
                box-shadow:
                    0 1px 3px rgba(0, 0, 0, 0.12),
                    0 1px 2px rgba(0, 0, 0, 0.24);
                border-bottom: 3px solid var(--theme-primary);
                line-height: normal !important;
                background: white;
                z-index: 1;
            }

            #profileMenu[opened] {
                display: block;
            }

            #profileMenuContent {
                position: relative;
                display: block;
                width: calc(100% - 60px);
                height: calc(100% - 60px);
                background: white;
                z-index: 3;
                padding: 30px;
                margin-bottom: 15px;
            }

            #closeBtn {
                position: absolute;
                bottom: 3px;
                width: 100%;
                display: flex;
                height: 20px;
                left: 0px;
                justify-content: center;
                color: var(--theme-primary);
                z-index: 3;
            }

            /* -------------------------------
    MOBILE LAYOUT = SAME AS LAYOUT-100
    ---------------------------------- */

            @media only screen and (max-width: 767px) {
                /* For mobile phones: */
                :host {
                    display: grid;
                    position: absolute;
                    top: 0;
                    right: 65px;
                    padding-top: 10px;
                }

                :host .contentOptionsIcon {
                    display: none;
                }

                :host .username {
                    display: none;
                }
            }
        `,
];
__decorate([
    property({ type: String })
], SDBNavUserMenu.prototype, "username", void 0);
__decorate([
    property({ type: Boolean })
], SDBNavUserMenu.prototype, "opened", void 0);
__decorate([
    property({ type: String })
], SDBNavUserMenu.prototype, "tooltipText", void 0);
__decorate([
    property({ type: String })
], SDBNavUserMenu.prototype, "tooltipPosition", void 0);
SDBNavUserMenu = __decorate([
    customElement('sdb-nav-usermenu')
], SDBNavUserMenu);
export { SDBNavUserMenu };
//# sourceMappingURL=sdb-nav-usermenu.js.map